import React, { ReactNode, createContext, useEffect, useState } from 'react'
import { AuthService } from '../apilibrary';
import { IUser } from '../apilibrary/types/user';

interface UserContextValue {
  user?: IUser
  setUser: (user: IUser | undefined) => void
}

const UserContext = createContext<UserContextValue>({
  setUser: () => { throw new Error('Not implemented') }
});

export interface UserContextProviderProps {
  children: JSX.Element | ReactNode
}

export const UserContextProvider: React.FC<UserContextProviderProps> = ({ children }) => {
  const [user, setUser] = useState<IUser>();
  const [fetchingUser, setFetchingUser] = useState<boolean>(true);

  useEffect(() => {
    const getCurrentAuthUser = async (): Promise<void> => {
      setFetchingUser(true);
      try {
        const user = await AuthService.getSavedAuthenticatedUser();
        setUser(user);
      } catch (error) {
        console.log(error);
      } finally {
        setFetchingUser(false);
      }
    }
    void getCurrentAuthUser();
  }, [])

  return (
    <UserContext.Provider value={{
      user,
      setUser
    }}>
      {fetchingUser ? (<div>Loading...</div>) : children}
    </UserContext.Provider>
  );
}

export default UserContext;
